import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FieldComponent } from '../field/field.component';
import { ProvidehttpService } from '../providehttp.service';
import { ServiceStock } from '../service-stock.service';

@Component({
  selector: 'app-range-bar',
  templateUrl: './range-bar.component.html',
  styleUrls: ['./range-bar.component.css']
})
export class RangeBarComponent extends FieldComponent implements OnInit {
  public leftValue: any;
  rangeVposition="0px";
  @Input('minValue') minValue: number;
  @Input('maxValue') maxValue: number;
  @Input('showMinMax') showMinMax: boolean=true;
  constructor(services: ServiceStock) {
    super(services);
  }

  ngOnInit() {
    this.value = this.minValue;
    this.bubblePosition(this.minValue);
  }
  bubblePosition(tempValue) {
    // const rangeV = document.getElementById('rangeV');
    const
      newValue = Number((tempValue - this.minValue) * 100 / (this.maxValue - this.minValue)),
      newPosition = 10 - (newValue * 0.2);
      this.rangeVposition  = `calc(${newValue}% + (${newPosition}px))`;
    // rangeV.style.left = `calc(${newValue}% + (${newPosition}px))`;

  }
  
  setValue(value, additionalInfo = undefined) {
    this.value = value;
    this.additionalInfo = additionalInfo;
    this.passNewValue(value);
    const rangeV = document.getElementById('rangeV');
    if (value < this.minValue) {

      //this.setValue(this.minValue);
      this.bubblePosition(this.minValue);


    } else if (value > this.maxValue) {
      //this.setValue(this.maxValue);
      this.bubblePosition(this.maxValue);
    }
    else {
      this.bubblePosition(this.value);
    }

  }

  async validateValue(value): Promise<number> {
    let totalErrors = 0;
    if (value < this.minValue) {
      this.setError("Value should be greater than " + this.minValue);
      totalErrors++;
    } else if (value > this.maxValue) {
      this.setError("Value should be less than " + this.maxValue);
      totalErrors++;
    }
    return totalErrors;  
  }

  onReset() {
    this.value = this.minValue;
    this.additionalInfo = undefined;
    this.error = false;
    this.errorCode = undefined;
    this.readOnly = false;
    this.dependencyMap.clear();
    this.fieldReset();
    this.bubblePosition(this.minValue);
  }
  getFieldInfo() {
    return (this.value == undefined) ? "" : this.value;
  }
  onChange(event) {
    if (event && event.stopPropagation) {
      event.stopPropagation();
    }
    this.change.emit();
    this.change.emit(this.value);
    this.blur.emit(this.value);
  }

}
